import React, { useState, useEffect } from 'react';
import { Table, Input, Tabs, Button, Modal, Form, Select,Popover, List, Typography , Menu as AntMenu } from 'antd';
import { EditOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { productsService } from "../../services/ProductsService";
import Menu from '../../components/Menu/Menu';
import './Bidding.scss';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MobileBottomMenu from '../../components/MobileBottomMenu/MobileBottomMenu';
import MobileMenu from "../../components/Menu/MobileMenu";
import Header from '../../components/Header/Header';
import { listService } from "../../services/ListService";
import { useLocation } from 'react-router-dom';
import { bidingService } from "../../services/BidingService";
const { Search } = Input;
const { TabPane } = Tabs;
const { Option } = Select;

const ListDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const location = useLocation();
    const [isScheduleModalVisible, setIsScheduleModalVisible] = useState(false);
    const [scheduleStep, setScheduleStep] = useState(1);
    const [scheduledDate, setScheduledDate] = useState(null);
    const [selectedSuppliersOption, setSelectedSuppliersOption] = useState('all');
    const [selectedList, setSelectedList] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [form] = Form.useForm();
    const [listExists, setListExists] = useState(false);
    const [listId, setListId] = useState(null);
    const [lists, setLists] = useState([]);
    const [currentList, setCurrentList] = useState(null);
    const [index, setIndex] = useState(-1);
    const [editingListId, setEditingListId] = useState(null);
    const [editedName, setEditedName] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isBulkDeleteModalVisible, setIsBulkDeleteModalVisible] = useState(false);
    const [offers, setOffers] = useState([]);

    const [rejectedIds, setRejectedIds] = useState([]);




    useEffect(() => {
        handleSearch('');

        listService.getLists()
            .then(res => {
                if (res.data) {
                    setLists(res.data);
                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });
    }, []);

    const handleSearch = (value) => {
        setSearchQuery(value);
        if (value.length > 0) {
            listService.searchList(value, 1)
                .then(res => {
                    if (res.data?.products) {
                        setSearchResults(res.data.products);
                    } else {
                        setSearchResults([]);
                    }
                })
                .catch(err => {
                    console.error("Eroare la căutare:", err);
                    setSearchResults([]);
                });
        } else {
            setSearchResults([]);
        }
    };

    useEffect(() => {
        if (id) {
            bidingService.getOffers(id)
                .then((res) => {
                    setOffers(res.data.items); 
                })
                .catch((err) => {
                    console.error("Error fetching offers:", err);
                });
        }
    }, []);
    const getInitials = (name) => {
        if (!name) return '';
        return name
          .split(' ')
          .map(word => word.charAt(0).toUpperCase())
          .join('');
      };

    const offerColumns = [
        {
            title: 'Produs',
            dataIndex: ['product', 'name'],
            key: 'product_name',
        },

       
  
        {
            title: 'Locul 1',
            key: 'locul1',
            render: (_, record) => {
              const bid = record.bids[0];
              return bid ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <div className='biding__initials'>
                    {getInitials(bid.supplier.name)}
                  </div>
                  <span>{bid.price} RON</span>
                
                </div>
              ) : '-';
            },
          },
          {
            title: 'Locul 2',
            key: 'locul2',
            render: (_, record) => {
              const bid = record.bids[1];
              return bid ? `${bid.price} RON (${bid.supplier.name})` : '-';
            },
          },
          {
            title: 'Locul 3',
            key: 'locul3',
            render: (_, record) => {
              const bid = record.bids[2];
              return bid ? `${bid.price} RON (${bid.supplier.name})` : '-';
            },
          },
             
          {
            title: 'Oferte totale',
            key: 'total_bids',
            render: (_, record) => {
              const content = record.bids.length > 0 ? (
                <List
                  size="small"
                  dataSource={record.bids}
                  renderItem={(bid, index) => (
                    <List.Item>
                      <Typography.Text>Locul {index + 1}:</Typography.Text>{' '}
                      {bid.supplier.name} - {bid.price} RON
                    </List.Item>
                  )}
                />
              ) : (
                <div>Nu există oferte.</div>
              );
        
              return (
                <Popover
                  content={content}
                  title="Toate ofertele"
                  trigger="hover"
                >
                  <Typography.Link>{record.total_bids}</Typography.Link>
                </Popover>
              );
            },
          },
        
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status'
           
        },
        {
            title: 'Actiuni',
            key: 'reject',
            render: (_, record) => {
              const isDisabled = rejectedIds.includes(record.id) || record.status === 'cancelled';
          
              return (
                <Button
                  type="primary"
                  danger
                  onClick={() => handleRejectOffers(record)}
                  disabled={isDisabled}
                >
                  Respinge oferte
                </Button>
              );
            },
          }
          
    ];
    const handleRejectOffers = (product) => {
        bidingService.rejectOffers(product.id, id)
          .then(() => {
            toast.success('Ofertele au fost respinse cu succes!');
            setRejectedIds((prev) => [...prev, product.id]);

          })
          .catch((error) => {
            console.error(error);
            toast.error('A apărut o eroare la respingerea ofertelor.');
          });
      };
    return (
        <div className='standard products list'>
            <Header />
            <div className='standard__mobile-header'>
                <img src='/images/logo.png' alt='logo' className='standard__only-mobile standard__mobile-logo' />
                <MobileMenu />
            </div>

            <div className='standard__container list'>
                <Menu />
                <div className='standard__wrapper'>
                    <div style={{ padding: 24, minHeight: 280 }}>
                    <h2 className='standard__page-title'>Liste in ofertare/Vezi oferte/Lista nr. {id}</h2>
                    <h4 className='standard__page-info'>
                            Aici urmaresti in timp real ofertele furnizorilor pentru produsele tale.
                        </h4>

                        <div className='list__search-box'>
                            <Search
                                className="list__search-input"
                                placeholder="Caută lista..."
                                onChange={(e) => handleSearch(e.target.value)}
                                value={searchQuery}
                                enterButton
                                allowClear
                                style={{ width: 300 }}
                            />

                        </div>
                        <Link to='/liste-in-ofertare' className='standard__link'>
                        <div className='biding__back'>
                            <img src="/images/back.png"/>
                            <h4>Înapoi</h4>
                        </div>
                        </Link>
                      


                        <div style={{ height: '600px', overflowY: 'auto' }}>
                            <Table
                                dataSource={offers}
                                columns={offerColumns}
                                rowKey="id"
                                pagination={false}
                                style={{ width: '100%' }}

                            />
                           
                        </div>


                    </div>
                </div>
            </div>


           

        </div>
    );
};

export default ListDetails;